import { Component, OnInit } from '@angular/core';

declare let ocultarLoader: Function;

@Component({
    template: '<br /><br /><h1>Page not found</h1>',
    selector: 'page-not-found'
})
export class PageNotFoundComponent implements OnInit{
    ngOnInit(){
        ocultarLoader();
    }
}